import { httpsCallable } from "firebase/functions";
import { functions } from ".";
import { isBooleanTrue, isStringEmpty, isStringNotEmpty } from "../utils/objectUtils";

// off the page's critical path, so a slow answer only delays the mark
const MARK_STAFF_BROWSER_TIMEOUT = 30000;

// the server checks the caller is staff, and records them, before it marks the visit
export const markStaffBrowser = async (siteVisitId) => {
    if (isStringEmpty(siteVisitId)) { return false; }

    const func = httpsCallable(functions, "markstaffbrowser", { timeout: MARK_STAFF_BROWSER_TIMEOUT });
    const result = await func({ siteVisitId: siteVisitId });

    return isBooleanTrue(result?.data?.isMarked);
};

export const getAffiliateConversionByLeadId = async (leadId) => {
    if (isStringNotEmpty(leadId)) {
        const func = httpsCallable(functions, "getaffiliateconversionbyleadid", { timeout: 6000000 });

        const res = await func({ leadId: leadId });

        return res.data;
    }

    return null;
};